<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Retención {{ numero_comprobante }}</h3>
        <label>
          <div v-show="estado === 'PPR' && anulado === 'N'" class="noti-warning">
            <strong>PENDIENTE DE AUTORIZACIÓN</strong>
          </div>
          <div v-show="anulado === 'S'" class="noti-danger">
            <strong>ANULADO</strong>
          </div>
          <div
            v-show="(estado === null || estado === undefined) && anulado === 'N' && !enColaAutorizacion"
            class="noti-info"
          >
            <strong>EMITIDO</strong>
          </div>
          <div v-show="estado === 'AUT' && anulado === 'N'" class="noti-success">
            <strong>AUTORIZADO</strong>
          </div>
          <div v-show="estado === 'N' && anulado === 'N'" class="noti-secondary">
            <strong>NUEVO</strong>
          </div>
          <div v-show="estado === 'NAT' && anulado === 'N'" class="noti-danger">
            <strong>NO AUTORIZADO</strong>
          </div>
          <div v-show="enColaAutorizacion" class="noti-primary">
            <strong>PENDIENTE DE ENVÍO AL SRI</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <button
          :disabled="!permiteAnularRetencion && !permiteEditarRetencion"
          @click="consultarComprobantes"
          class="btn-bus200 btn--bigger"
          type="button"
        >
          <i class="fa fa-search"></i>
          <span>Buscar comprobantes</span>
        </button>
        <modal width="85%" height="auto" scrollable name="listaComprobantes">
          <lista-comprobantes
            @selected="selectedComprobante"
            :tipoComprobante="tipoComprobanteConsulta"
          ></lista-comprobantes>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información de la retención</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-field">
                    <div class="form-group">
                      <input-field
                        :readonly="form.id_tipo_comprobante_afectado !== ''"
                        v-model="form.numero_comprobante_afectado"
                        type="tel"
                        v-mask="'###-###-#########'"
                        id="comprobanteAfectado"
                        placeholder="N° comprobante"
                      >
                        <span>Comprobante afectado</span>
                        <span
                          v-if="errores.numero_comprobante_afectado"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.numero_comprobante_afectado[0] }}</strong>
                        </span>
                      </input-field>
                      <button
                        :disabled="!editable"
                        @click="consultarComprobantesVenta"
                        v-show="form.id_tipo_comprobante_afectado === ''"
                        class="btn-info"
                        type="button"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                      <button
                        :disabled="!editable"
                        @click="quitarComprobanteAfectado"
                        v-show="form.id_tipo_comprobante_afectado !== ''"
                        class="btn-danger"
                      >
                        <i class="fa fa-ban"></i>
                      </button>
                      <modal name="comprobantesAfectados" height="auto" width="80%" scrollable>
                        <lista-comprobantes-compra
                          @selected="selectedComprobante"
                          :tipoComprobante="codigoFactura"
                        ></lista-comprobantes-compra>
                      </modal>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      :disabled="form.id_tipo_comprobante_afectado !== ''"
                      id="fecha_emision_comprobante_afectado"
                      v-model="form.fecha_emision_comprobante_afectado"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label>Fecha de emisión del comprobante</label>
                    <span
                      v-if="errores.fecha_emision_comprobante_afectado"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_emision_comprobante_afectado[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <input-field
                    v-model="identificacion_cliente"
                    :readonly="(form.id_cliente !== null && form.id_cliente !== '')"
                    id="identificacion"
                    placeholder="# Identificación"
                  >
                    Identificación *
                    <span
                      v-if="errores.id_cliente"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.id_cliente[0] }}</strong>
                    </span>
                  </input-field>
                  <button
                    @click="consultarCliente"
                    v-show="(form.id_cliente === null || form.id_cliente === '') && form.id_tipo_comprobante_afectado === '' && estado === 'N'"
                    type="button"
                    class="btn-success"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    @click="quitarCliente"
                    v-show="((form.id_cliente !== null && form.id_cliente !== '' && form.id_tipo_comprobante_afectado === ''))"
                    type="button"
                    class="btn-danger"
                  >
                    <i class="fa fa-ban"></i>
                  </button>
                  <modal scrollable width="70%" height="auto" name="persona">
                    <persona
                      tipoFiltro="P"
                      :numeroIdentificacion="identificacion_cliente"
                      @saved="savedPersona"
                      :searchButton="false"
                    ></persona>
                  </modal>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <input-field
                      v-model="nombre_cliente"
                      readonly
                      id="cliente"
                      placeholder="Nombre de cliente"
                    >
                      <span>Proveedor *</span>
                    </input-field>
                    <button
                      v-show="estado === 'N' && form.id_tipo_comprobante_afectado === ''"
                      @click="consultarPersonas"
                      type="button"
                      class="btn-info"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    :disabled="!editable"
                    v-model="form.email"
                    id="email"
                    placeholder="Correo del cliente"
                  >
                    <span>E-mail ("," para separar varios)</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div :class="{'select2--disabled' : estado !== 'N'}" class="form-field select2">
                  <div class="select2-field">
                    <v-select
                      label="descripcion"
                      :options="puntosEmision"
                      v-model="selectedPuntoEmision"
                      id="punto_emision"
                      placeholder="Seleccione..."
                    ></v-select>
                    <label for="punto_emision">Punto de emisión</label>
                    <span
                      v-if="errores.id_punto_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.id_punto_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="!esElectronico && estado === 'N'" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field v-mask="'#########'" type="tel" id="numero_documento" v-model="form.numero_documento" placeholder="#########">
                    <span>Número de documento</span>
                    <span
                        v-if="errores.numero_documento"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.numero_documento[0] }}</strong>
                      </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      id="fecha_emision"
                      v-model="form.fecha_emision"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label for="fecha_emision">Fecha de emisión (retención)</label>
                    <span
                      v-if="errores.fecha_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    v-model="form.numero_autorizacion"
                    readonly
                    placeholder="#############"
                    id="numero_autorizacion"
                  >
                    <span>N° Autorización</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    v-model="clave_acceso"
                    readonly
                    id="clave_acceso"
                    placeholder="################"
                  >
                    <span>Clave de acceso</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      disabled
                      id="fecha_autorizacion"
                      v-model="form.fecha_autorizacion"
                      locale="es"
                      no-label
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm:ss"
                      formatted="YYYY-MM-DD HH:mm:ss"
                      label="Seleccione una fecha..."
                    />
                    <label for="fecha_autorizacion">Fecha de autorización (retención)</label>
                  </div>
                </div>
              </div>
              <div v-show="false" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <label for="tipo_emision">Tipo de emisión</label>
                    <v-select
                      :options="tiposEmision"
                      label="descripcion"
                      v-model="selectedTipoEmision"
                      id="tipo_emision"
                      placeholder="Seleccione..."
                    ></v-select>
                    <span
                      v-if="errores.id_tipo_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.id_tipo_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="no_anular_consumidor_final_aut" class="col-xs-12">
                <div class="noti-info">
                  <p> 
                    <i class="fa fa-info-circle"></i>
                    Recuerda enviar tus comprobantes electrónicos el mismo día de su emisión para evitar sanciones. según lo establece la resolución NAC-DGERCGC25-00000014.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <tabla-detalle-retencion
            :disabled="!editable"
            :codigoIva="codigoIva"
            :codigoIsd="codigoIsd"
            :codigoRenta="codigoRenta"
            :baseImponibleIsd="baseImponibleIsd"
            :baseImponibleRenta="baseImponibleRenta"
            :baseImponibleIva="baseImponibleIva"
            @input="inputDetalleRetencion"
            :impuestos="impuestos"
            :errores="errores"
            v-model="form.detalles"
            :fechaEmision="form.fecha_emision"
            :sustentosTributarios="sustentosTributarios"
          ></tabla-detalle-retencion>
        </div>
        <div class="row mt-3">
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="card__title">
                <h5>Detalles adicionales</h5>
              </div>
              <div class="card__content">
                <tabla-informacion-adicional
                  :disabled="!editable"
                  :errores="errores"
                  v-model="form.detallesAdicionales"
                ></tabla-informacion-adicional>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="card__title">
                <h5>Totales</h5>
              </div>
              <div class="card__content">
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="isd"
                        readonly
                        placeholder="$ ##.##"
                        id="totalISD"
                      >
                        <span>Total ISD</span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="iva"
                        readonly
                        placeholder="$ ##.##"
                        id="totalIva"
                      >
                        <span>Total IVA</span>
                      </input-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="renta"
                        readonly
                        placeholder="$ ##.##"
                        id="totalRenta"
                      >
                        <span>Total Renta</span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="total"
                        readonly
                        placeholder="$ ##.##"
                        id="totalRetenido"
                      >
                        <span>Total Retenido</span>
                      </input-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              :disabled="(estado === 'N' && !permiteCrearRetencion) || (estado !== 'N' && !permiteEditarRetencion) || enColaAutorizacion"
              v-show="estado !== 'PPR'"
              @click="guardarComprobante"
              class="btn-success"
              type="button"
            >
              <i class="fa fa-save"></i>
              <span>Guardar</span>
            </button>
            <button
              :disabled="!permiteCrearRetencion"
              @click="nuevoComprobante"
              type="button"
              class="btn-light btn--text"
            >
              <i class="fa fa-plus"></i>
              <span>Nuevo</span>
            </button>
            <button
              :disabled="!permiteAnularRetencion"
              @click="anularRetencion"
              v-show="estado !== 'N' && anulado === 'N'"
              type="button"
              class="btn-danger btn--text"
            >
              <i class="fa fa-ban"></i>
              <span>Anular</span>
            </button>
            <button
              :disabled="!permiteAnularRetencion"
              @click="enviarComprobantesAnulados"
              v-show="anulado === 'S' && estado === 'AUT' && esElectronico"
              type="button"
              class="btn-primary btn--text"
            >
              <i class="fa fa-envelope"></i>
              <span>Enviar comprobante anulado</span>
            </button>
            <button
              @click="imprimirComprobante"
              v-show="estado !== 'N'"
              type="button"
              class="btn-bus200 btn--text"
            >
              <i class="fa fa-print"></i>
              <span>Imprimir</span>
            </button>
            <button @click="verAnterior" type="button" class="btn-primary btn--text">
              <i class="fa fa-toggle-left"></i>Anterior
            </button>
            <button @click="verSiguiente" type="button" class="btn-primary btn--text">
              <i class="fa fa-toggle-right"></i>Siguiente
            </button>
            <button
              v-show="estado !== 'N'"
              @click="abrirLogs"
              type="button"
              class="btn-secondary btn--text"
            >
              <i class="fa fa-file-o"></i>
              <span>Logs</span>
            </button>
            <button
              v-show="estado === 'AUT' && intento_correo"
              class="btn-dark btn--text"
              type="button"
              @click="enviarCorreo"
            >
              <i class="fa fa-envelope-o"></i>
              <span>Enviar correo</span>
            </button>
            <button
              @click="autorizar"
              v-show="estado !== 'N' && (estado === undefined || estado === null) && anulado === 'N'  && !enColaAutorizacion && ((permiteAutorizarRet))"
              class="btn-primary btn--text"
            >
              <i class="fa fa-paper-plane"></i>
              <span>Autorizar</span>
            </button>
            <button
              @click="mostrarAuditorias"
              class="btn-info btn--text"
              type="button"
              v-show="estado !== 'N'"
            >
              <i class="fa fa-file"></i>
              <span>Auditorías</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal width="70%" name="coincidenciaComprobantes" height="auto" scrollable>
      <coincidencia-comprobantes
        @seleccionar="seleccionarComprobanteAfectado"
        @cerrar="$modal.hide('coincidenciaComprobantes')"
        :comprobantes="comprobantesConsultados"
      ></coincidencia-comprobantes>
    </modal>
    <modal width="55%" height="auto" name="listaPersonas" scrollable>
      <lista-personas tipoFiltro="P" :filterStatus="false" @selected="selectedPersona"></lista-personas>
    </modal>
    <modal width="50%" name="imprimir" height="auto" scrollable>
      <imprimir :id_comprobante="id_comprobante"></imprimir>
    </modal>
    <modal width="50%" name="auditorias" height="auto" scrollable>
      <auditorias ref="auditorias" @cancelar="cancelarAuditorias" :id_comprobante="id_comprobante"></auditorias>
    </modal>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      sustentosTributarios: [],
      id_comprobante: "",
      identificacion_cliente: "",
      nombre_cliente: "",
      numero_comprobante: "",
      no_anular_consumidor_final_aut: false,
      rucProveedor: '',
      form: {
        numero_documento: '',
        id_cliente: "",
        numero_comprobante_afectado: "",
        id_tipo_comprobante_afectado: "",
        id_tipo_comprobante: this.tipoComprobante,
        fecha_emision_comprobante_afectado: "",
        detalles: [],
        detallesAdicionales: [],
        id_punto_emision: "",
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        _method: undefined,
        email: "",
        numero_autorizacion: "",
        fecha_autorizacion: null
      },
      intento_correo: false,
      clave_acceso: "",
      selectedPuntoEmision: null,
      selectedTipoEmision: null,
      url: url,
      tiposEmision: [],
      puntosEmision: [],
      estado: "N",
      errores: {
        id_cliente: undefined,
        numero_comprobante_afectado: undefined,
        id_tipo_comprobante_afectado: undefined,
        id_tipo_comprobante: undefined,
        fecha_emision_comprobante_afectado: undefined,
        detalles: undefined,
        detallesAdicionales: undefined,
        id_punto_emision: undefined
      },
      anulado: "N",
      tipoComprobanteConsulta: this.tipoComprobante,
      comprobantesConsultados: [],
      impuestos: [],
      baseImponibleIva: null,
      baseImponibleRenta: null,
      baseImponibleIsd: null,
      money: money,
      codigoIva: "",
      codigoIsd: "",
      codigoRenta: "",
      codigoFactura: "",
      codigoRetencion: "",
      enColaAutorizacion: false
    };
  },
  updated: function() {
    let that = this;
    let numeroDocumento = document.getElementById("comprobanteAfectado");
    if (numeroDocumento !== undefined && numeroDocumento !== null)
      numeroDocumento.onblur = function() {
        let parts = numeroDocumento.value.split("-");
        let nuevoNumero = null;
        if (parts.length === 3)
          nuevoNumero =
            parts[0] + "-" + parts[1] + "-" + parts[2].padStart(9, "0");
        else {
          nuevoNumero = numeroDocumento.value
            .replace("-", "")
            .replace("-", "")
            .padStart(15, "0");
          nuevoNumero =
            nuevoNumero.substr(0, 3) +
            "-" +
            nuevoNumero.substr(3, 3) +
            "-" +
            nuevoNumero.substr(6, 9);
        }
        that.form.numero_comprobante_afectado = nuevoNumero;
      };
  },
  props: {
    permiteAutorizarRet: {
      type: Boolean,
      required: true
    },
    tipoComprobante: {
      required: true,
      type: String
    },
    comprobante: {
      required: false,
      type: Object,
      default: function() {
        return null;
      }
    },
    permiteCrearRetencion: {
      type: Boolean,
      required: true
    },
    permiteEditarRetencion: {
      type: Boolean,
      required: true
    },
    permiteAnularRetencion: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    'form.fecha_emision': function(value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == "Invalid Date") {
            swal("Error", "La fecha de emisión es incorrecta", "error");
            this.form.fecha_emision = null;
          }
          else {
            date.setHours(date.getHours() + 5);
            let fechaActual = new Date();
            fechaActual.setHours(0);
            if (date > fechaActual) {
              swal("Error", "La fecha de emisión no puede ser futura", "error");
              this.form.fecha_emision = null;
            } 
            else {
              this.validarRentaPorFecha(this.form.fecha_emision );
            }
          }
        }
      }
    },
    selectedPuntoEmision: function(value) {
      if (value !== undefined && value !== null) {
        this.form.id_punto_emision = value.id;
        if (this.estado === "N" && value.tipo === "M") {
          this.form.numero_autorizacion = value.numero_autorizacion;
          this.form.fecha_autorizacion = moment(
            new Date(value.fecha_autorizacion)
          ).format("YYYY-MM-DD");
        } else if (this.estado === "N") {
          this.form.numero_autorizacion = "";
          this.form.fecha_autorizacion = null;
        }
      } else {
        this.form.id_punto_emision = "";
        this.numero_comprobante = "";
      }
      this.cargarNumeroActual();
    },
    selectedTipoEmision: function(value) {
      if (value !== undefined && value !== null)
        this.form.id_tipo_emision = value.id_tipo_emision;
      else this.form.id_tipo_emision = "";
    }
  },
  methods: {
    cargarNumeroActual: function () {
      if (this.selectedPuntoEmision != null && !this.esElectronico && this.selectedPuntoEmision.precargar_numero === 'S') {
        axios.get(url + '/' + this.selectedPuntoEmision.id + '/numero-actual').then(({data}) => {
          this.form.numero_documento = data.numero_actual;
        });
      }
    },
    validarRentaPorFecha: function(date) {
      if(this.form.detalles.length == 0)
        return;
      let that = this;
      let urlApi = url + '/impuestos/obtener-fecha-habilitacion/' + date;
      axios.get(urlApi).then(function (response) {
        if(response.data == null)
          return;
        let fechaMasCercana = moment(response.data + " 00:00:00").format("YYYY-MM-DD");
        let fechaHabilitacion = null;
        let detalles = [];
        let valido = true;
        let eliminados = 0;
        for (let i = 0; i < that.form.detalles.length; i++) {        
          valido = true;
          if (
            that.form.detalles[i].selectedTarifa != null &&
            that.form.detalles[i].selectedTarifa.id_impuesto == '1'  
          ) {
            if(that.form.detalles[i].selectedTarifa.fecha_habilitacion != null){
              fechaHabilitacion = moment(that.form.detalles[i].selectedTarifa.fecha_habilitacion + " 00:00:00").format("YYYY-MM-DD");
              if (fechaMasCercana != fechaHabilitacion) {
                valido = false;
                eliminados++;
              }
            }
          }
          if (valido)
            detalles.push(that.form.detalles[i]);
        }    
        that.form.detalles = JSON.parse(JSON.stringify(detalles));
        if (eliminados > 0) {
          let mensaje = 'Se han eliminado ' + eliminados + ' detalles de Renta porque la fecha de habilitación de la tarifa no coincide';
          swal('Aviso', mensaje, 'warning');
        }
      });     
    },
    enviarComprobantesAnulados: function() {
      let that = this;
      swal({
        title: "¿Desea enviar el comprobante anulado?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(
              that.url +
                "/comprobantes/" +
                that.id_comprobante +
                "/correos-anulados"
            )
            .then(function(response) {
              if (response.data.enviado)
                swal(
                  "El comprobante ha sido enviado por correo electrónico.",
                  "Aviso",
                  "success"
                );
              else
                swal(
                  "No se ha otorgado direcciones electrónicas que puedan recibir el comprobante electrónico.",
                  "Aviso",
                  "success"
                );
            })
            .catch(function(error) {
              swal(
                "Hubo un error al intentar enviar el comprobante.",
                "Aviso",
                "warning"
              );
            });
        }
      });
    },
    verAnterior: function() {
      let numeroDocumento = this.numero_comprobante;
      if (this.numero_comprobante != null && this.numero_comprobante != "")
        numeroDocumento = numeroDocumento.replace("-", "").replace("-", "");
      else numeroDocumento = "9".padStart(15, "9");
      let that = this;
      axios
        .get(
          url +
            "/comprobantes/" +
            this.tipoComprobante +
            "/" +
            numeroDocumento +
            "/N/cargar"
        )
        .then(function(response) {
          if (response.data.id_comprobante != null)
            location.href =
              url +
              "/comprobantes?tipo_comprobante=" +
              that.tipoComprobante +
              "&id_comprobante=" +
              response.data.id_comprobante;
          else swal("No se encontró otro comprobante.", "Aviso", "warning");
        });
    },
    verSiguiente: function() {
      let numeroDocumento = this.numero_comprobante;
      if (this.numero_comprobante != null && this.numero_comprobante != "")
        numeroDocumento = numeroDocumento.replace("-", "").replace("-", "");
      else numeroDocumento = "9".padStart(15, "9");
      let that = this;
      axios
        .get(
          url +
            "/comprobantes/" +
            this.tipoComprobante +
            "/" +
            numeroDocumento +
            "/S/cargar"
        )
        .then(function(response) {
          if (response.data.id_comprobante != null)
            location.href =
              url +
              "/comprobantes?tipo_comprobante=" +
              that.tipoComprobante +
              "&id_comprobante=" +
              response.data.id_comprobante;
          else swal("No se encontró otro comprobante.", "Aviso", "warning");
        });
    },
    autorizar: function() {
      let that = this;
      swal({
        title: "¿Desea autorizar este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Autorizar comprobante",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(that.url + "/autorizacion-documentos", {
              comprobantes: [that.id_comprobante]
            })
            .then(function(response) {
              swal(
                "El comprobante ha sido enviado a autorizar.",
                "Aviso",
                "success"
              );
              that.enColaAutorizacion = "S";
            })
            .catch(function(error) {
              swal(
                "Hubo un error al intentar autorizar el documento, intente nuevamente.",
                "Aviso",
                "warning"
              );
            });
        }
      });
    },
    cancelarAuditorias: function() {
      this.$modal.hide("auditorias");
    },
    mostrarAuditorias: function() {
      this.$modal.show("auditorias");
    },
    abrirLogs: function() {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/logs",
        "_blank"
      );
    },
    enviarCorreo: function() {
      let that = this;
      axios
        .post(this.url + "/comprobantes/" + this.id_comprobante + "/correo")
        .then(function(response) {
          let comprobantesAfectados = response.data.comprobantesAfectados;
          if (comprobantesAfectados > 0)
            swal(
              "El comprobante ha sido enviado a la cola de envío de correos electrónicos.",
              "Aviso",
              "success"
            );
          else
            swal("No se ha enviado el correo electrónico.", "Aviso", "warning");
        });
    },
    consultarComprobantesVenta: function() {
      this.tipoComprobanteConsulta = this.codigoFactura;
      this.$modal.show("comprobantesAfectados");
    },
    inputDetalleRetencion: function(value) {
      this.form.detalles = value;
    },
    seleccionarComprobanteAfectado: function(comprobante) {
      this.tipoComprobanteConsulta = this.codigoFactura;
      this.selectedComprobante(comprobante);
      this.$modal.hide("coincidenciaComprobantes");
    },
    obtenerInformacionAdicional: function(nombre) {
      for (let i = 0; i < this.form.detallesAdicionales.length; i++)
        if (this.form.detallesAdicionales[i].nombre_campo === nombre)
          return this.form.detallesAdicionales[i];
      return null;
    },
    selectedPersona: function(persona) {
      this.$modal.hide("listaPersonas");
      this.identificacion_cliente = persona.identificacion;
      this.form.id_cliente = persona.id;
      this.nombre_cliente = persona.nombre;
      this.form.email = persona.email;
      let informacionEmail = this.obtenerInformacionAdicional("Email");
      if (informacionEmail === null)
        this.form.detallesAdicionales.push({
          nombre_campo: "Email",
          valor_campo: persona.email
        });
      else informacionEmail.valor_campo = persona.email;
      let informacionTelefono = this.obtenerInformacionAdicional("Teléfono");
      if (persona.telefono !== null) {
        if (informacionTelefono === null)
          this.form.detallesAdicionales.push({
            nombre_campo: "Teléfono",
            valor_campo: persona.telefono
          });
        else informacionTelefono.valor_campo = persona.telefono;
      } else if (informacionTelefono !== null)
        this.form.detallesAdicionales.splice(
          this.form.detallesAdicionales.indexOf(informacionTelefono),
          1
        );
      let informacionDireccion = this.obtenerInformacionAdicional("Dirección");
      if (informacionDireccion === null)
        this.form.detallesAdicionales.push({
          nombre_campo: "Dirección",
          valor_campo: persona.direccion
        });
      else informacionDireccion.valor_campo = persona.direccion;
    },
    savedPersona: function(persona) {
      this.selectedPersona(persona);
      this.$modal.hide("persona");
    },
    nuevoComprobante: function() {
      swal({
        title: "¿Desear crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          this.form = {
            id_cliente: "",
            numero_comprobante_afectado: "",
            id_tipo_comprobante_afectado: "",
            id_tipo_comprobante: this.tipoComprobante,
            fecha_emision_comprobante_afectado: "",
            detalles: [],
            detallesAdicionales: [],
            id_punto_emision: "",
            fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
            numero_autorizacion: "",
            fecha_autorizacion: ""
          };
          this.enColaAutorizacion = false;
          this.intento_correo = false;
          this.fecha_autorizacion = null;
          this.numero_comprobante = "";
          this.identificacion_cliente = "";
          this.nombre_cliente = "";
          this.form.email = "";
          this.estado = "N";
          this.anulado = "N";
          this.id_comprobante = "";
          this.clave_autorizacion = "";
          this.baseImponibleIva = null;
          this.baseImponibleRenta = null;
          this.baseImponibleIsd = null;
          this.selectedPuntoEmision = null;
          this.selectedTipoEmision = null;
          this.clave_acceso = "";
          if (this.tiposEmision.length > 0)
            this.selectedTipoEmision = this.tiposEmision[0];
          if (this.puntosEmision.length > 0)
            this.selectedPuntoEmision = this.puntosEmision[0];
          this.ponerDetalleAdicional();
        }
      });
    },
    consultarPersonas: function() {
      this.$modal.show("listaPersonas");
    },
    imprimirComprobante: function() {
      if (this.selectedPuntoEmision.punto_venta === "S")
        this.$modal.show("imprimir");
      else
        window.open(
          this.url + "/comprobantes/" + this.id_comprobante + "/ride",
          "_blank"
        );
    },
    anularRetencion: function() {
      let that = this;
      swal({
        title: "¿Desea anular este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular comprobante",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(
              that.url + "/comprobantes/" + that.id_comprobante + "/anular",
              {
                _method: "DELETE"
              }
            )
            .then(function(response) {
              that.anulado = "S";
              if (response.data.error_correos)
                swal(
                  "El comprobante ha sido anulado pero no pudo enviarse por correo electrónico.",
                  "Anulado",
                  "warning"
                );
              else
                swal("El comprobante ha sido anulado.", "Anulado", "success");
            });
        }
      });
    },
    cargarDatosFormulario: function() {
      let that = this;
      axios
        .get(
          this.url +
            "/comprobantes/" +
            this.tipoComprobante +
            "/datos-retencion"
        )
        .then(function(response) {
          that.sustentosTributarios = response.data.sustentosTributarios;
          that.tiposEmision = response.data.tiposEmision;
          if (that.tiposEmision.length > 0)
            that.selectedTipoEmision = that.tiposEmision[0];
          that.puntosEmision = response.data.puntosEmision;
          if (that.puntosEmision.length > 0)
            that.selectedPuntoEmision = that.puntosEmision[0];
          that.impuestos = response.data.impuestos;
          that.codigoIva = response.data.codigoIva;
          that.codigoIsd = response.data.codigoIsd;
          that.codigoRenta = response.data.codigoRenta;
          that.codigoFactura = response.data.codigoFactura;
          that.codigoRetencion = response.data.codigoRetencion;
          that.no_anular_consumidor_final_aut = response.data.no_anular_consumidor_final_aut == 'S';
          that.rucProveedor = response.data.rucProveedor;
          if (that.comprobante !== null)
            that.selectedComprobante(that.comprobante);
          else
            that.ponerDetalleAdicional();
        });
    },
    ponerDetalleAdicional: function () {
      if (this.rucProveedor != null && this.rucProveedor != '') {
        const existeRucProveedor = this.form.detallesAdicionales.some(
          (item) => item.nombre_campo === "RUC Proveedor"
        );
        if (!existeRucProveedor) {
          this.form.detallesAdicionales.push({
            enviar_sri: true,
            nombre_campo: "RUC Proveedor",
            valor_campo: this.rucProveedor,
          });
        }
      }
    },
    guardarDefinitivo: function () {
      let cantidadIva = 0;
      let cantidadIsd = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIva
        )
          cantidadIva++;
        else if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIsd
        )
          cantidadIsd++;
      if (cantidadIsd > 1) {
        swal(
          "No puede retenerse más de una vez el IVA y el ISD.",
          "Mensaje",
          "warning"
        );
        return;
      }
      this.errores = {
        id_cliente: undefined,
        numero_comprobante_afectado: undefined,
        id_tipo_comprobante_afectado: undefined,
        id_tipo_comprobante: undefined,
        fecha_emision_comprobante_afectado: undefined,
        detalles: undefined,
        detallesAdicionales: undefined,
        id_punto_emision: undefined
      };
      let that = this;
      let urlRequest = this.url + "/comprobantes/retencion";
      if (that.estado !== "N") {
        urlRequest += "/" + this.id_comprobante;
        that.form._method = "PUT";
      } else that.form._method = undefined;
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          that.estado = response.data.id_estado_comprobante;
          that.numero_comprobante =
            response.data.codigo_establecimiento +
            "-" +
            response.data.codigo_emisor +
            "-" +
            response.data.numero_secuencial;
          that.id_comprobante = response.data.id_comprobante;
          if (that.selectedPuntoEmision.tipo === "E")
            that.clave_acceso = response.data.clave_acceso;
          swal({
            title:
              "El comprobante fue almacenado con éxito. ¿Deseas imprimir el comprobante?",
            text: "Esta acción requiere de confirmación.",
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Imprimir",
            cancelButtonText: "No"
          }).then(result => {
            if (result.value) that.imprimirComprobante();
          });
        })
        .catch(function(error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                swal(
                  "Hay errores de validación, verifique el formulario.",
                  "Error",
                  "warning"
                );
                that.errores = response.data.errors;
              } else if (response.status === 403)
                swal(
                  "El punto de emisión manual ha llegado a su límite o ha expirado, por favor, actualice la secuencia del mismo.",
                  "Aviso",
                  "warning"
                );
              else if (response.status !== 404)
                swal("Hubo un error, intente nuevamente.", "Error", "error");
              else
                swal(
                  "Hubo un error al momento de almacenar los datos, procure no repetir los detalles de retención e intente nuevamente.",
                  "Error",
                  "error"
                );
            }
          }
        });
    },
    guardarComprobante: function() {
      let fechaComp = new Date(this.form
              .fecha_emision_comprobante_afectado + ' 00:00:00');
      let fechaEmision = new Date(this.form
              .fecha_emision + ' 00:00:00');
      if (fechaEmision < fechaComp) {
        swal('La fecha de emisión no puede ser menor a la fecha del comprobante.', 'Aviso', 'warning');
        return;
      }
      axios
        .get(url + "/comprobantes/retencion/factura-retenida", {
          params: {
            numero_comprobante_afectado:
              this.estado === "N" ? this.form.numero_comprobante_afectado : "X",
            fecha_emision_comprobante_afectado: this.form
              .fecha_emision_comprobante_afectado,
            id_cliente: this.form.id_cliente,
          },
        })
        .then(({ data }) => {
          if (data.length > 0) {
            let message =
              "El comprobante ya tiene aplicadas las siguientes retenciones:<br>";
            for (let i = 0; i < data.length; i++) {
              message +=
                data[i].id_tarifa +
                " (" +
                decimalFormat(data[i].tarifa) +
                "%)<br>";
            }
            message += "¿Desea continuar?";
            swal({
              title: "Confirmación",
              html: message,
              type: "question",
              showCancelButton: true,
              confirmButtonText: "Guardar",
              cancelButtonText: "No",
            }).then((result) => {
              if (result.value) {
                this.guardarDefinitivo();
              }
            });
          } else {
            this.guardarDefinitivo();
          }
        });
    },
    consultarComprobanteAfectado: function() {
      if (this.form.numero_comprobante_afectado !== "") {
        let that = this;
        axios
          .get(this.url + "/compras/" + this.form.numero_comprobante_afectado, {
            params: {
              tipoComprobanteAfectado: this.codigoFactura
            }
          })
          .then(function(response) {
            if (response.data.length > 0) {
              if (response.data.length === 1) {
                that.tipoComprobanteConsulta = that.codigoFactura;
                that.selectedComprobante(response.data[0]);
              } else {
                that.comprobantesConsultados = response.data;
                that.$modal.show("coincidenciaComprobantes");
              }
            } else {
              that.quitarComprobanteAfectado();
              swal(
                "No se encontró comprobantes con el número proporcionado.",
                "Mensaje",
                "warning"
              );
            }
          });
      } else
        swal("Debe ingresar un número de comprobante.", "Aviso", "warning");
    },
    quitarComprobanteAfectado: function() {
      this.form.numero_comprobante_afectado = "";
      this.form.id_tipo_comprobante_afectado = "";
      this.form.fecha_emision_comprobante_afectado = "";
    },
    consultarComprobantes: function() {
      this.tipoComprobanteConsulta = this.tipoComprobante;
      this.$modal.show("listaComprobantes");
    },
    selectedComprobante: function(comprobante) {
      if (this.tipoComprobanteConsulta !== this.tipoComprobante)
        if (comprobante.estado === "I") {
          swal("El comprobante ha sido anulado.", "No permitido", "warning");
          return;
        }
      this.form.detalles = [];
      if (this.tipoComprobanteConsulta === this.tipoComprobante) {
        this.selectedTipoEmision = null;
        for (let i = 0; i < this.tiposEmision.length; i++)
          if (
            this.tiposEmision[i].id_tipo_emision === comprobante.id_tipo_emision
          ) {
            this.selectedTipoEmision = this.tiposEmision[i];
            break;
          }
        this.enColaAutorizacion = comprobante.pendiente_envio === "S";
        this.selectedPuntoEmision = null;
        this.form.id_cliente = comprobante.id_persona;
        this.nombre_cliente = comprobante.nombre_cliente;
        this.form.email = comprobante.correo_cliente;
        this.identificacion_cliente = comprobante.numero_identificacion;
        this.intento_correo = comprobante.intento_correo;
        this.form.numero_comprobante_afectado =
          comprobante.numeracion_comp_venta;
        this.form.id_tipo_comprobante_afectado = comprobante.id_tipo_comp_venta;
        this.form.fecha_emision_comprobante_afectado = moment(
          new Date(comprobante.fecha_emision_comp_venta)
        ).format("YYYY-MM-DD");
        this.anulado = comprobante.anulado;
        this.numero_comprobante =
          comprobante.codigo_establecimiento +
          "-" +
          comprobante.codigo_emisor +
          "-" +
          comprobante.numero_secuencial;
        this.form.fecha_emision = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
        this.id_comprobante = comprobante.id_comprobante;
        this.estado = comprobante.id_estado_comprobante;
        for (let i = 0; i < this.puntosEmision.length; i++)
          if (
            this.puntosEmision[i].numero_secuencia ===
              comprobante.codigo_emisor &&
            this.puntosEmision[i].localidad.numero_localidad ===
              comprobante.codigo_establecimiento
          ) {
            this.selectedPuntoEmision = this.puntosEmision[i];
            break;
          }
        if (comprobante.fecha_autorizacion !== null) {
          if (
            this.selectedPuntoEmision !== null &&
            this.selectedPuntoEmision.tipo === "E"
          )
            this.form.fecha_autorizacion = moment(
              new Date(comprobante.fecha_autorizacion)
            ).format("YYYY-MM-DD HH:mm");
          else
            this.form.fecha_autorizacion = moment(
              new Date(comprobante.fecha_autorizacion)
            ).format("YYYY-MM-DD");
        } else this.form.fecha_autorizacion = null;
        this.form.numero_autorizacion = comprobante.numero_autorizacion;
        this.clave_acceso = comprobante.clave_acceso;
        this.form.detallesAdicionales = [];
        for (let i = 0; i < comprobante.detalles_adicionales.length; i++)
          this.form.detallesAdicionales.push({
            nombre_campo: comprobante.detalles_adicionales[i].nombre,
            valor_campo: comprobante.detalles_adicionales[i].valor
          });
        this.form.detalles = [];
        for (let i = 0; i < comprobante.impuestos.length; i++) {
          if (comprobante.impuestos[i].comprobante !== null) {
            let comp = comprobante.impuestos[i].comprobante;
            if (comprobante.impuestos[i].id_impuesto === "2")
              baseImponibleIva = comprobante.impuestos[i].base_imponible;
            else if (comprobante.impuestos[i].id_impuesto === "6")
              baseImponibleIsd = comprobante.impuestos[i].base_imponible;
            else baseImponibleRenta = comprobante.impuestos[i].base_imponible;
          }
          this.form.detalles.push({
            id_tarifa: comprobante.impuestos[i].id_tarifa,
            base_imponible: comprobante.impuestos[i].base_imponible,
            porcentaje: comprobante.impuestos[i].tarifa,
            valor: comprobante.impuestos[i].valor,
            selectedImpuesto: comprobante.impuestos[i].impuesto,
            selectedTarifa: comprobante.impuestos[i].porcentaje,
            id_sustento_tributario: comprobante.impuestos[i].id_sustento_tributario,
            numero_cajas: comprobante.impuestos[i].numero_cajas,
            precio_caja: comprobante.impuestos[i].precio_caja
          });
        }
        this.$modal.hide("listaComprobantes");
      } else {
        this.form.numero_comprobante_afectado = comprobante.numero;
        this.form.id_tipo_comprobante_afectado = comprobante.codigo_documento;
        this.form.fecha_emision_comprobante_afectado = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
        this.baseImponibleIva = parseFloat(comprobante.valor_iva);
        this.baseImponibleRenta = parseFloat(comprobante.total_sin_impuestos);
        this.baseImponibleIsd = parseFloat(comprobante.total_sin_impuestos);
        this.nombre_cliente = comprobante.razon_social;
        this.identificacion_cliente = comprobante.ruc;
        this.form.id_cliente = comprobante.id_persona;
        this.form.email = comprobante.persona.email;
        this.selectedPersona(comprobante.persona);
        this.$modal.hide("comprobantesAfectados");
      }
    },
    consultarCliente: function() {
      if (this.identificacion_cliente !== "") {
        let that = this;
        axios
          .get(this.url + "/personas/" + this.identificacion_cliente, {
            params: {
              tipoFiltro: "P"
            }
          })
          .then(function(response) {
            that.selectedPersona(response.data);
          })
          .catch(function(error) {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                let status = response.status;
                if (status === 404) {
                  swal({
                    title: "¿Desear crear una nueva persona?",
                    text: "Esta acción requiere de confirmación.",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: "Nueva persona",
                    cancelButtonText: "No"
                  }).then(result => {
                    if (result.value) that.crearNuevaPersona();
                  });
                } else
                  swal(
                    "Hubo un error al momento de consultar el número. Intente nuevamente.",
                    "Error",
                    "error"
                  );
              }
            }
          });
      } else
        swal("Debe ingresar un número de identificación.", "Aviso", "warning");
    },
    quitarCliente: function() {
      this.nombre_cliente = "";
      this.form.id_cliente = "";
      this.form.email = "";
      let informacionEmail = this.obtenerInformacionAdicional("Email");
      if (informacionEmail !== null)
        this.form.detallesAdicionales.splice(
          this.form.detallesAdicionales.indexOf(informacionEmail),
          1
        );
      let informacionTelefono = this.obtenerInformacionAdicional("Teléfono");
      if (informacionTelefono !== null)
        this.form.detallesAdicionales.splice(
          this.form.detallesAdicionales.indexOf(informacionTelefono),
          1
        );
      let informacionDireccion = this.obtenerInformacionAdicional("Dirección");
      if (informacionDireccion !== null)
        this.form.detallesAdicionales.splice(
          this.form.detallesAdicionales.indexOf(informacionDireccion),
          1
        );
    },
    crearNuevaPersona: function() {
      this.$modal.show("persona");
    }
  },
  mounted: function() {
    this.cargarDatosFormulario();
  },
  computed: {
    esElectronico: function() {
      return this.selectedPuntoEmision !== null
        ? this.selectedPuntoEmision.tipo === "E"
        : false;
    },
    editable: function() {
      return (
        (this.estado === "N" ||
          this.estado === "NAT" ||
          this.estado === null ||
          this.estado === undefined) &&
        this.anulado !== "S" &&
        !this.enColaAutorizacion
      );
    },
    isd: function() {
      let isd = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIsd
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          isd += valor;
        }
      return isd;
    },
    iva: function() {
      let iva = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIva
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          iva += valor;
        }
      return iva;
    },
    renta: function() {
      let renta = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoRenta
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          renta += valor;
        }
      return renta;
    },
    total: function() {
      return this.isd + this.iva + this.renta;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Retencion.vue